import { AfterViewInit, ChangeDetectorRef, Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[ohpFocusOnLoad]'
})
export class FocusOnLoadDirective implements AfterViewInit {

    @Input('ohpFocusOnLoad') public focusOnLoad: boolean;

    @Input() public detectChanges: boolean;

    constructor(
        private readonly elementRef: ElementRef,
        private readonly changeDetectorRef: ChangeDetectorRef
    ) {}

    public ngAfterViewInit() {
        if (this.focusOnLoad) {
            this.elementRef.nativeElement.focus();
            if (this.detectChanges) {
                this.changeDetectorRef.detectChanges();
            }
        }
    }
}
